<template>
  <section>
    <h1 class="text-h3 mb-8">
      Tooltips
    </h1>
    <v-sheet
      class="mb-4 px-6 py-4"
      outlined
      rounded
    >
      <div class="d-flex">
        <v-checkbox
          v-model="arrow"
          label="Arrow (Custom style)"
        />
      </div>
      <div class="d-flex align-center justify-space-around text-center">
        <v-tooltip
          v-for="position in positions"
          :key="position"
          :content-class="arrow ? 'arrow ' + position : ''"
          v-bind="{ [position]: true }"
        >
          <template #activator="{ on, attrs }">
            <v-btn
              color="primary"
              dark
              v-bind="attrs"
              v-on="on"
            >
              {{ position }}
            </v-btn>
          </template>
          <span class="text-capitalize">{{ position }} tooltip</span>
        </v-tooltip>
      </div>
      <v-alert
        class="mt-6"
        type="info"
        text
      >
        When use <strong>arrow</strong> style tooltip, you need to add <code>arrow</code> and position (top, right, bottom or left) to <code>content-class</code> manually.<br>
        Also, you can not set the color of the arrow style tooltip.
      </v-alert>
    </v-sheet>
    <h2 class="text-h4 mb-4">
      Further reading
    </h2>
    <external-link href="https://vuetifyjs.com/en/components/tooltips/">
      <strong>Tooltips</strong>
    </external-link>
  </section>
</template>

<script>
export default {
  name: 'ComponentsTooltips',
  data: () => ({
    arrow: false,
    positions: [
      'left',
      'top',
      'bottom',
      'right'
    ]
  })
}
</script>
